<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap"><a id="page_vii">Editor’s Acknowledgments</a></h2><a id="page_vii">
<p class="noindent"><i><span class="big">E</span><span class="small">THNOGRAPHIC</span> E<span class="small">NCOUNTERS IN</span> I<span class="small">SRAEL</span></i> emerged from a series of conversations that I had with Tamir Erez and Dafna Shir-Vertesh about the paucity of written texts dealing with fieldwork in Israel, and how we might remedy that lack. At first my aim was to compile a Hebrew language collection for use in Israeli universities. But Tamir and Dafna had a better idea. They insisted on an English language volume that would address an international audience of anthropologists—students, teachers, generalists, and specialists. I thank Tamir and Dafna for their wisdom.</p>
<p class="indent">Rebecca Tolen of Indiana University Press embraced this project and nurtured it at every stage. It has been wonderful to work with a sponsoring editor who is an experienced anthropologist as well as extraordinarily skilled in the nuances of the English language.</p>
<p class="indent">Along with my Introduction, this volume consists of eleven original essays by eleven remarkable anthropologists. Some of the contributors are at the very beginning of their academic careers; others are well established, while most are somewhere in between. It has been a great pleasure to work with all of them. My only regret is that submissions by Don Handelman, Smadar Lavie, Amalia Sa’ar, and Dafna Shir-Vertesh could not be included in this book. I look forward to seeing their essays published elsewhere.</p>
<p class="indent">I am grateful to those of my teachers, colleagues and students who have in some way inspired this volume. Most of all, it has benefitted from the brilliance of Shmuel Ben-Dor and Tania Forte, to whose blessed memories this book is dedicated.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_ack.vue?d606f9e0